// extracted by mini-css-extract-plugin
export default {"img":"ImagePreview_img__xbqAf"};